import { Button, Center, Stack, Text, Title } from "@mantine/core";
import { useNavigate } from "react-router-dom";
import { STYLE } from "@jasper/shared";
import { UseAuth } from "/@/contexts";

export const AccessDenied = () => {
  const { logOut } = UseAuth();
  const navigate = useNavigate();

  const handleLogOut = async () => {
    if (await logOut()) {
      navigate("/");
    }
  };

  return (
    <Center style={{ height: "100vh", padding: "1rem" }}>
      <Stack align="center" gap="md">
        <Title order={3} style={{ color: STYLE.primary }}>
          Access denied
        </Title>
        <Text ta="center">Your account does not have access to labs.</Text>
        <Button
          color={STYLE.primary}
          data-testid="dentist-logout-button"
          onClick={handleLogOut}
        >
          Log out
        </Button>
      </Stack>
    </Center>
  );
};
